'use client';

// npm packages
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { useState } from 'react';
// components
import { cn } from '@/utils/cn';
import { useSelector } from 'react-redux';
import Icon from '../Icon';
import Text from '../Text';

// utils

function FixedFooterNavigation({ className }) {
  const pathname = usePathname();

  const { isMenuOpen, isSubMenuOpen } = useSelector(
    (state) => state.hamburgerMenu,
  );

  const [isHovered, setIsHovered] = useState(false);

  const footerMenu = [
    {
      name: 'home',
      icon: 'home',
      url: '/',
    },
    {
      name: 'categories',
      icon: 'categories',
      url: '/categories',
    },
    {
      name: 'campaigns',
      icon: 'offers',
      url: '/campaign',
    },
    {
      name: 'my singer',
      icon: 'my-singer',
      url: '/my-singer',
    },
  ];

  const handleClick = (link) => {
    // if (link === "categories") {
    //   router.push("/products");
    // }
  };

  const handleMouseEvent = (url, event) => {
    if (event === 'mouseEnter') {
      setIsHovered(url);
    } else {
      setIsHovered(false);
    }
  };

  const isActive = (url) => pathname === url;

  const getColor = (url) => {
    if (isHovered === url) {
      return '#DB0032';
    }
    if (isActive(url)) {
      return '#DB0032';
    }
    return '#49525E';
  };

  return (
    <footer
      className={cn(
        'fixed-footer-navigation bg-titanwhite mt-[200px] block lg:hidden fixed bottom-0 left-0 right-0 z-[512] shadow-footer-navbar',
        className,
        {
          hidden: isMenuOpen || isSubMenuOpen,
        },
      )}
    >
      <div className="mx-auto">
        <div className="flex justify-between gap-0 sm:gap-[8px] mx-4">
          {footerMenu?.map((item, index) => (
            <Link
              prefetch={false}
              aria-label={`Go to footer menu item ${item.name}`}
              href={item.url}
              key={index}
              className={cn(
                "min-w-[68px] w-[80px] max-w-[100px] flex flex-col justify-center items-center px-6 py-5 group relative after:transition-all after:duration-200 after:content-[''] after:w-full after:h-[2px] after:bg-transparent hover:after:bg-richcarmine after:block after:absolute after:left-0 after:bottom-0",
                {
                  'after:!bg-richcarmine': isActive(item.url),
                },
              )}
            >
              <div className="size-[30px] flex justify-center items-center mb-6">
                <Icon type={item.icon} color={getColor(item.url)} />
              </div>
              <Text
                type="span"
                className={cn(
                  'text-[12px] text-riverbed group-hover:text-richcarmine text-center font-semibold leading-16 capitalize tracking-[0.24px] line-clamp-1',
                  {
                    '!text-richcarmine': isActive(item.url),
                  },
                )}
              >
                {item.name}
              </Text>
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default FixedFooterNavigation;
